export default {
  darkerPrimary: "#0056B3",
  darkestPrimary: "#1F4166",
  lighterPrimary: "#4695EA",
  lightestPrimary: "#E5F2FF",
  primary: "#006FE6"
};
